import { TireClassification } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const TIRE_CLASSIFICATION_ICON: Record<TireClassification, NoddiIconName> = {
  [TireClassification.PREMIUM]: 'ShieldCheck',
  [TireClassification.QUALITY]: 'ThumbsUp',
  [TireClassification.ECONOMY]: 'PiggyBank',
  [TireClassification.BUDGET]: 'HandCoins',
  [TireClassification.FIXED_COST]: 'Lock',
  [TireClassification.UNCLASSIFIED]: 'CircleHelp'
};
